import { Link } from 'react-router-dom'

export function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner container">
        <span>© {new Date().getFullYear()} Originalene</span>
        <nav className="footer-links">
          <Link to="/info#vilkar">Vilkår</Link>
          <Link to="/info#kontakt">Kontakt</Link>
        </nav>
      </div>
    </footer>
  )
}
